import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import { currency } from './../../../helpers/';

export const ProductSingle = props => {
    const {
        name,
        currency_sign,
        image,
        description,
        button_label,
        url
    } = props.singlePackage;

    const specialClass = props.bg_colour === 'White' ? 'white_bg' : 'blue_bg';

    const style = {
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    }

    const price = currency.convert( props.singlePackage.price );


    return (// columns below switched for flexbox
        <div className={`product--portal row ${ specialClass }`}>
            <div className="product__image flex-column--image" style={ style }> 
                <div className="product__price price">
                    { currency_sign && <span className="price__currency">{ price.substring( 0, 1 ) }</span> }
                    { props.singlePackage.price && <span className="price__amount">{ price }</span> }
                    <span className="price__subtitle">{ `+ ${ currency.taxType() }` }</span>
                </div>
            </div>
            <div className="padding-none flex-column--description">
                { name && <h4 className="h4">{ name }</h4> }
                <div className="product__container">
                    { description &&
                        <div className="product__description">
                            { description && description.length > 0 && RichText.render( description ) }
                        </div>
                    }
                    <a href={ url } target="_blank" className="package__button">
                        <button className="btn btn-primary btn-shadow">{ button_label }</button>
                    </a>
                </div>
            </div>
        </div>
    );
}

ProductSingle.propTypes = {
    singlePackage: PropTypes.shape({
        product_payment_uid: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        price: PropTypes.string,
        price_small: PropTypes.string,
        currency_sign: PropTypes.string,
        icon: PropTypes.string,
        text_under_icon: PropTypes.string,
        text_under_price: PropTypes.string,
        is_recommedned: PropTypes.shape({
            id: PropTypes.string,
            is_recommedned: PropTypes.string
        }),
        features: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.array
        }))
    })
}



// WEBPACK FOOTER //
// src/client/components/slices/products/ProductSingle.js